import BuyNowModal from 'components/modals/BuyNowModal';
import ConfirmModal from 'components/modals/ConfirmModal';
import MakeOfferModal from 'components/modals/MakeOfferModal';
import MarketplaceBalanceModal from 'components/modals/MarketplaceBalanceModal';
import MintModal from 'components/modals/MintModal';
import PlaceBidModal from 'components/modals/PlaceBidModal';
import PreSignModal from 'components/modals/PreSignModal';
import RemoveListingsModal from 'components/modals/RemoveListingsModal';
import SelfDestructCollectionModal from 'components/modals/SelfDestructCollectionModal';
import SellModal from 'components/modals/SellModal';
import NoticeModal from 'components/modals/v2/NoticeModal';

/**
 * These are Modals that are used across the entire app.
 * They are rendered here so that they are accessible to trigger via the useModal hook.
 *
 * Most modals should not go here, only those that are programatically triggered.
 * Most modals are triggered by buttons, and should be rendered only on pages/components that need them.
 */
export function GlobalModals() {
  return (
    <>
      <ConfirmModal />
      <NoticeModal />
      <PreSignModal />
      <PlaceBidModal />
      <MintModal />
      <MarketplaceBalanceModal />
      <SellModal />
      <RemoveListingsModal />
      <BuyNowModal />
      <MakeOfferModal />
      <SelfDestructCollectionModal />
    </>
  );
}
